import Accordion from '@/components/ui/Accordion';
import { PERGUNTAS } from '../conteudo';

// Perguntas frequentes — Accordion (reaproveitado das perguntas já existentes).
export default function Perguntas() {
  return (
    <section className="app-entra mt-10" style={{ animationDelay: '240ms' }}>
      <h2 className="text-[19px] font-extrabold text-foreground-950 md:text-[24px]">
        {PERGUNTAS.titulo}
      </h2>
      <div className="mt-4 flex flex-col gap-2.5">
        {PERGUNTAS.itens.map((item) => (
          <Accordion key={item.pergunta} titulo={item.pergunta}>
            <p className="text-[14px] leading-relaxed text-foreground-600">{item.resposta}</p>
          </Accordion>
        ))}
      </div>
    </section>
  );
}